<div class="root" role="status">
  <span class="visually-hidden">Loading...</span>
</div>
